/**
   * @prop --stzh-pagetitle-home-heading-color: Color of the heading
   * @prop --stzh-pagetitle-home-subheading-color: Color of the subheading and readspeaker slot
 */

:host {
  ::slotted([slot="image"]) {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ::slotted([slot="heading"]) {
    --color: var(--stzh-pagetitle-home-heading-color, #{$colorSecondary50});
  }

  ::slotted([slot="subheading"]) {
    --color: var(--stzh-pagetitle-home-heading-color, #{$headingColor});
  }

  ::slotted([slot="readspeaker"]) * {
    --color: var(--stzh-pagetitle-home-readspeaker-color, #{$headingColor});
    --hover-color: var(--stzh-pagetitle-home-readspeaker-color, #{$headingColor});
  }

  &[has-image] ::slotted([slot="readspeaker"]) * {
    --color: var(--stzh-pagetitle-home-readspeaker-color, #{$colorWhite});
    --hover-color: var(--stzh-pagetitle-home-readspeaker-color, #{$colorWhite});
  }

  &[has-image] ::slotted([slot="heading"]) {
    --color: var(--stzh-pagetitle-home-heading-color, #{$colorLemonyellow50});
  }

  &[has-image] ::slotted([slot="subheading"]) {
    --color: var(--stzh-pagetitle-home-subheading-color, #{$colorWhite});
  }
}

.stzh-pagetitle-home {
  position: relative;
  @include spaceCurve('padding-bottom', 'large');

  &__container {
    @include container;
  }

  &__text {
    @include spaceCurve('padding-top', 'big');
    @include spaceCurve('padding-bottom', 'big');
    @include grid;
  }

  &__image-wrapper {
    position: relative;
  }

  &__image-inner-wrapper {
    position: absolute;
    inset: 0;
    height: 100%;
    margin-left: calc(#{$containerMargin} / -1);
    margin-right: calc(#{$containerMargin} / -1);

    @include mq($from: small) {
      margin-left: calc(#{$containerMarginSmall} / -1);
      margin-right: calc(#{$containerMarginSmall} / -1);
    }

    @include mq($from: medium) {
      margin-left: 0;
      margin-right: 0;
      width: calc(100% + #{$containerMarginMedium});
    }

    @include mq($from: large) {
      width: calc(100% + #{$containerMarginLarge});
    }

    @include mq($from: ultra) {
      width: calc(100% + ((#{map-get($breakpoints, 'ultra')} - #{$containerMaxWidth}) / 2));
    }
  }

  &__image-gradient {
    position: absolute;
    background: linear-gradient(1.21deg, rgba(0, 0, 0, 0) 31.71%, rgba(0, 0, 0, 0.5) 83.84%);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;

    @include mq($from: small) {
      background: linear-gradient(270deg, rgba(0, 0, 0, 0) 31.21%, rgba(0, 0, 0, 0.5) 91.45%);
    }

    @include mq($from: ultra) {
      left: calc((100vw - #{$containerMaxWidth}) / 2);

      &:before {
        content: '';
        position: absolute;
        background: rgba(0, 0, 0, 0.5);
        top: 0;
        right: calc((100vw - #{$containerMaxWidth}) / 2 + #{$containerMaxWidth} - var(--stzh-scrollbar-width, 0px));
        bottom: 0;
        left: calc((100vw - #{$containerMaxWidth}) / 2 * -1 - var(--stzh-scrollbar-width, 0px));
        z-index: 1;
      }
    }
  }


  &__meta {
    display: flex;
    flex-direction: column-reverse;
    row-gap: space('xsmall');
    @include spaceCurve('margin-bottom', 'regular');

    @include mq($from: medium) {
      flex-direction: row;
    }
  }

  &__readspeaker {
    @include mq($from: small, $to: medium) {
      --stzh-readspeaker-dropdown-position: relative;
      --stzh-readspeaker-dropdown-top: auto;
    }
  }

  &__subheading {
    --stzh-base-lead-color: #{$headingColor};
  }

  &__heading:not(:empty) + &__subheading:not(:empty) {
    @include spaceCurve('margin-top', 'tiny');
  }

  &__heading,
  &__subheading,
  &__meta {
    grid-column: 1 / span 4;

    @include mq($from: medium) {
      grid-column: 1 / span 10;
    }
  }

  &__ratio {
    --max-height: 680px;
    --overflow: hidden;
  }

  /* Has no image variant */

  &--has-no-image &__ratio {
    display: none;
  }

  &--has-no-image &__text {
    @include spaceCurve('padding-top', 'regular');
  }

  /* Has image variant */

  &--has-image {
    padding-bottom: 0;
  }

  &--has-image &__container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1;
  }

  &--has-image &__text {
    @include spaceCurve('padding-top', 'large');
  }

  /* Hyphens */
  &--hyphens &__heading {
    hyphens: auto;
  }
}
